// extracted by mini-css-extract-plugin
module.exports = {"dialogHeader":"styles_dialogHeader__3aSDR","dialogContent":"styles_dialogContent__beIEY"};